module.exports = __webpack_public_path__ + "static/media/clouds.1164ddcb.webm";